import { useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthShell } from "@/components/layout/AuthShell";
import { Spinner } from "@/components/common/States";
import { useMe } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nProvider";

const GoogleIcon = () => (
  <svg viewBox="0 0 48 48" className="w-5 h-5" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

export default function SignIn() {
  const { t } = useI18n();
  const { isLoaded, isSignedIn, signInWithGoogle } = useMe();
  const [params] = useSearchParams();
  const [busy, setBusy] = useState(false);
  const next = params.get("next") || "/";
  const error = params.get("error_description");
  if (!isLoaded || params.get("code")) return <AuthShell><Spinner /></AuthShell>;
  if (isSignedIn) return <Navigate to={next.startsWith("/") && !next.startsWith("//") ? next : "/"} replace />;

  const go = async () => {
    setBusy(true);
    const { error: e } = await signInWithGoogle(next);
    if (e) setBusy(false);
  };
  return (
    <AuthShell>
      <div className="bay-card w-full max-w-[400px] p-8 text-center" data-testid="sign-in-card">
        <h1 className="text-2xl font-bold text-navy">{t("sauth.title")}</h1>
        <p className="mt-2 text-sm text-ink-muted">{t("sauth.subtitle")}</p>
        {error && <p data-testid="sign-in-error" className="mt-4 text-sm text-red-700">{error}</p>}
        <button type="button" onClick={go} disabled={busy} data-testid="google-sign-in-btn"
          className="mt-6 w-full h-12 inline-flex items-center justify-center gap-3 rounded-full border border-line bg-white text-navy font-semibold hover:border-gold transition-colors disabled:opacity-60">
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <GoogleIcon />}{t("sauth.google")}
        </button>
        <p className="mt-6 text-xs text-ink-muted">{t("sauth.note")}</p>
      </div>
    </AuthShell>
  );
}
